import { useEffect, useState } from "react";
import instance from "api/cmsapi";
import { extractIndicatorListFromCmsPayload, resolveDpatCmsYear } from "utils/dpatIndicatorCmsHelpers";

/**
 * True when `dpat-indicator/year/{year}` resolves to an empty indicator list for that year.
 */
export function useDpatCmsYearSetup(year) {
  const [loading, setLoading] = useState(false);
  const [empty, setEmpty] = useState(false);
  const [error, setError] = useState(null);

  const cmsYear = resolveDpatCmsYear(year);

  useEffect(() => {
    if (cmsYear == null || cmsYear === "") {
      setEmpty(false);
      setLoading(false);
      setError(null);
      return undefined;
    }
    let cancelled = false;
    setLoading(true);
    setError(null);
    (async () => {
      try {
        const { data } = await instance.get(`dpat-indicator/year/${cmsYear}`);
        if (cancelled) return;
        const list = extractIndicatorListFromCmsPayload(data);
        setEmpty(Array.isArray(list) && list.length === 0);
      } catch (e) {
        if (!cancelled) {
          setError(e?.message || "Could not load DPAT indicator setup");
          setEmpty(false);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [cmsYear]);

  return { cmsYearSetupLoading: loading, cmsYearSetupEmpty: empty, cmsYearSetupError: error };
}
